import { Fragment, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHeader from "./TableHeader";
import TopicRow from "./TopicRow";
import AddTypeModal from "./AddTypeModal";
import { SIZES } from "@asez/shared";
import { STATIC_STRINGS } from "@asez/shared";

const RenderTable = ({ topicsData }: { topicsData: any }) => {
  const [isModalOpen, setModalOpen] = useState<string>("");
  const [newQuestion, setNewQuestion] = useState({
    index: 0,
    questionType: STATIC_STRINGS.MCQ,
    difficultyLevel: STATIC_STRINGS.EASY,
    numberOfQuestions: 1,
    additionalRequirements: "",
  });
  return (
    <>
      <div className="overflow-auto max-w-full h-[90%]">
        <Table
          stickyHeader
          size={SIZES.sm}
          sx={{
            width: "100%",
            tableLayout: "fixed",
          }}
        >
          <TableHeader />
          <TableBody>
            {topicsData?.map((topic, topicIndex) => (
              <Fragment key={topicIndex}>
                <TopicRow
                  topic={topic}
                  topicIndex={topicIndex}
                  setModalOpen={setModalOpen}
                  setNewQuestion={setNewQuestion}
                />
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </div>
      {isModalOpen && (
        <AddTypeModal
          newQuestion={newQuestion}
          setNewQuestion={setNewQuestion}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
};
export default RenderTable;
